import QRCode from "qrcode";

export function totpManualKey(otpauthUri: string): string {
  try {
    return new URL(otpauthUri).searchParams.get("secret") ?? "";
  } catch {
    return "";
  }
}

export async function totpQrDataUrl(otpauthUri: string): Promise<string> {
  const svg = await QRCode.toString(otpauthUri, {
    type: "svg",
    margin: 2,
    width: 220,
    errorCorrectionLevel: "M",
    color: { dark: "#03070D", light: "#ffffff" },
  });
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
